import React from "react";
import LayoutFacebookAutomation from "../views/newFacebookCampaign/LayoutFacebookAutomation";
import LayoutGoogleAutomation from "../views/newGoogleCampaign/LayoutGoogleAutomation";
import SocialCalendarLayout from "../views/socialCalendar/SocialCalendarLayout";
import NewPost from "../views/socialCalendar/NewPost";
import Repository from "../views/repository/Repository";
import CreativeApproval from "../views/creativeApproval/CreativeApproval";
import Dashboard from "../views/dashboard/Dashboard";
import NotFoundPage from "../components/common/NotFound";



// Define the routes here as an array of objects
const appRoutes = [
  {
    path: "/Ad-Manager/Facebook-Ad-Manage",
    element: <LayoutFacebookAutomation />,
  },
  {
    path: "/Ad-Manager/Google-Ad-Manage",
    element: <LayoutGoogleAutomation />,
  },
  {
    path: "/social_calendar",
    element: <SocialCalendarLayout />,
  },
  {
    path: "/social_calendar/new_post",
    element: <NewPost />,
  },
  {
    path: "/social_calendar/edit_post/:editId",
    element: <NewPost />,
  },
  {
    path: "/repository",
    element: <Repository />,
  },
  {
    path: "/creative_approval",
    element: <CreativeApproval />,
  },
  {
    path: "/dashboard",
    element: <Dashboard/>,
  },
  {
    path: "/not-found",
    element: <NotFoundPage/>,
  },
];

export default appRoutes;
